import AxiosClient from "../AxiosClient";

// 商品明細IDで取得
export const getProductDetailByProductId = (productId) => {
  const url = "/api/productDetail/searchInfoList";
  const params = { productId };
  return AxiosClient.post(url, params);
};

// 商品明細を取得
export const getProductDetail = (params) => {
  const url = "/api/productDetail/searchInfoList";
  return AxiosClient.post(url, params);
};

// 商品明細を登録
export const insertProductDetail = (params) => {
  const url = "/api/productDetail/insertInfo";
  return AxiosClient.post(url, params);
};

// 商品明細を編集
export const updateProductDetail = (params) => {
  const url = "/api/productDetail/updateInfo";
  return AxiosClient.post(url, params);
};

// 商品明細を削除
export const deleteProductDetail = (params) => {
  const url = "/api/productDetail/deleteInfo";
  return AxiosClient.post(url, params);
};

